<svelte:options tag={null} />

<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';
  export let id: string | undefined = undefined;
  export let quantity = 1;
  export let valuemin = 1;
  export let valuemax = 100;
  export let placeholder: string | undefined = undefined;
  export let small = false;

  let eventHandler = new EventHandler();

  function handleValue(): void {
    if (quantity > valuemax) {
      quantity = valuemax;
    }
    if (quantity < valuemin) {
      quantity = valuemin;
    }
    eventHandler.dispatch('input', quantity);
  }

  function decrement(): void {
    if (quantity > valuemin) {
      quantity--;
    }
    eventHandler.dispatch('decrement', quantity);
  }

  function increment(): void {
    if (quantity < valuemax) {
      quantity++;
    }
    eventHandler.dispatch('increment', quantity);
  }
</script>

<div class="mc-quantity-selector" {...$$restProps}>
  <button
    aria-controls={id}
    class="mc-button mc-button--square mc-button--bordered mc-quantity-selector__button-left {small
      ? 'mc-button--s'
      : ''}"
    aria-label="Decrement"
    on:click={() => decrement()}
    disabled={quantity === valuemin}
  >
    <span class="mc-button__icon">
      <navigation-control-less-32px size="100%" />
    </span>
  </button>

  <input
    {id}
    {placeholder}
    bind:value={quantity}
    on:input|preventDefault={handleValue}
    type="number"
    name="quantity-selector-input"
    class="mc-text-input mc-quantity-selector__input {small
      ? 'mc-button--s'
      : ''}"
    aria-label="QuantitySelector"
    aria-valuemin={valuemin}
    aria-valuemax={valuemax}
    aria-valuenow={quantity}
    spellcheck="false"
  />

  <button
    aria-controls={id}
    class="mc-button mc-button--square mc-button--bordered mc-quantity-selector__button-right {small
      ? 'mc-button--s'
      : ''}"
    aria-label="Increment"
    on:click={() => increment()}
    disabled={quantity === valuemax}
  >
    <span class="mc-button__icon">
      <navigation-control-more-32px size="100%" />
    </span>
  </button>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.text-input';
  @import '@mozaic-ds/styles/components/_c.button';
  @import '@mozaic-ds/styles/components/_c.quantity-selector';
</style>
